/*
 * Get insurances from autocomplete list
 */
import { clientFetch } from '../clientFetch';

export const getInsurancesAutoComplete = (value, limit = false) => {
  return clientFetch('/autocomplete/insurance', { params: { input: value, limit } });
};
